<template>
  <v-slide-y-transition group>
    <component
      v-if="ready && currentComponent"
      :is="currentComponent"
      :key="currentStep"
      :loan="loan"
      @delegation-complete="handleDelegationComplete"
      @contract-complete="handleContractComplete"
    />
  </v-slide-y-transition>
</template>

<script>
export default {
  data() {
    return {
      uuid: this.$route.params.uuid,
      loanRequestType: null,
      loan: null,
      ready: false,
      currentStep: null, // 'delegation' 또는 'contract'
    }
  },
  async created() {
    try {
      // 대출 정보, 기존 동의서 목록을 함께 조회
      const [loanRequest, loanDetail, agreements] = await Promise.all([
        this.$defaultApi.getLoansRequestByLoan(this.uuid),
        this.$defaultApi.getLoansDetail(this.uuid),
        this.$store.dispatch('agreement/getContractAgreements'),
      ])

      this.loanRequestType = loanRequest.data?.type
      this.loan = loanDetail.data

      // BNPL_JANGSA3 타입이고 대금지급위임 동의서가 없는 경우에만 delegation 단계 필요
      const hasDelegationAgreement = agreements.some(
        (item) =>
          item.term?.code === 'BNPL_JANGSA3_PAYMENT_DELEGATION' &&
          item.isAgreed === true &&
          item.offer?.uuid === this.loan.offer.uuid,
      )

      this.currentStep =
        this.loan?.type === 'BNPL_JANGSA3' && !hasDelegationAgreement ? 'delegation' : 'contract'

      this.ready = true
    } catch (error) {
      console.error('Failed to fetch loan data:', error)
      await this.$router.replace({ name: 'earlypay' })
    }
  },
  computed: {
    currentComponent() {
      // BNPL_JANGSA3 타입이고 위임동의서 단계인 경우
      if (this.loan?.type === 'BNPL_JANGSA3' && this.currentStep === 'delegation') {
        return () => import('@/pages/loan/contracts/ContractPaymentDelegation.vue')
      }

      // 일반 계약서 단계
      if (this.currentStep === 'contract') {
        if (this.loanRequestType === 'creditpay') {
          return () => import('@/pages/loan/contracts/ContractForCreditpay.vue')
        } else if (this.loanRequestType === 'woori_crowd') {
          return () => import('@/pages/loan/contracts/ContractForWooriCrowd.vue')
        } else {
          return () => import('@/pages/loan/contracts/ContractDefault.vue')
        }
      }

      return null
    },
  },
  methods: {
    // 대금지급위임 동의서 작성 완료
    handleDelegationComplete() {
      this.currentStep = 'contract'
    },

    // 계약서 작성 완료
    async handleContractComplete() {
      await this.$router.replace({ name: 'earlypay' })
    },
  },
}
</script>

<style lang="scss" scoped></style>
